module.exports = __webpack_public_path__ + "static/media/maintnbg.46971c22.png";